/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of all applications on the device.
 */
export enum ApplicationsSummaryStatusType {
  ApplicationsSummaryStatusHealthy = 'Healthy',
  ApplicationsSummaryStatusDegraded = 'Degraded',
  ApplicationsSummaryStatusError = 'Error',
  ApplicationsSummaryStatusUnknown = 'Unknown',
  ApplicationsSummaryStatusNoApplications = 'NoApplications',
}
